module.exports = __webpack_public_path__ + "static/media/viva_garden_02_B.7033e510.png";